import React, { createContext, useState, useContext, useEffect, useRef } from 'react';
import { collection, getDocs, doc, getDoc, query, orderBy } from "firebase/firestore";
import { db, auth } from "../utils/firebase"
import { onAuthStateChanged,} from "firebase/auth";
import updateFirestoreTrophies from '../utils/trophies-won';
import {vocabMatches} from "../utils/other-utils";



const DataContext = createContext();

export const MyDataProvider = ({ children }) => {

  const [data, setData] = useState('Hello from context!');
  const [synonyms, setSynonyms] = useState([]);
  const [summaryData, setSummaryData] = useState(null)
  const [defAndSent, setDefAndSent] = useState({})
  const [todaysVocab, setTodaysVocab] = useState([])
  const [videoVocab, setVideoVocab] = useState({})
  const [includedVocab, setIncludedVocab] = useState([])
  const [start, setStart] = useState(0)
  const [quizPoints, setQuizPoints] = useState([])
  const [trophiesWon, setTrophiesWon] = useState({});
  const [videoID, setVideoID] = useState("");
  const [trophyKey, setTrophyKey] = useState("")
  const [user, setUser] = useState(undefined); // notice: undefined, not null
  const [videos, setVideos] = useState([])
  const [vocabMatchesBool, setVocabMatchesBool] = useState(false)
  const [vocabLoaded, setVocabLoaded] = useState(false);
  const ttsUsageRef = useRef({ count: 0, date: "" });
  const lookUpRef = useRef({ count: 0, date: "" });
  const cardsSwipedRef = useRef(0)
  const [tempUserWords, setTempUserWords] = useState([])
  const [userWordsCount, setUserWordsCount] = useState(0);
  const [loadingUser, setLoadingUser] = useState(true)

//   onAuthStateChanged(auth, (firebaseUser) => {
//   console.log("Auth change:", firebaseUser);
// });


  useEffect(() => {
  if (Array.isArray(todaysVocab) && Array.isArray(videoVocab)) {
    setVocabMatchesBool(vocabMatches(todaysVocab, videoVocab));
  } else {
    setVocabMatchesBool(false);
  }
}, [todaysVocab, videoVocab]);

// useEffect(() => {
//   if (user === null) {
//     clearUserData();
//   }
// }, [user]);


  //  useEffect(() => {
  //     if (vocabLoaded && Array.isArray(todaysVocab) && todaysVocab.length > 0) {
  //       localStorage.setItem("todaysVocab", JSON.stringify(todaysVocab));
  //     }
  //   }, [todaysVocab, vocabLoaded]);

        useEffect(() => {
      const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
        if (firebaseUser) {
          setUser(firebaseUser); 
          await loadFullUserProfile(firebaseUser);
        } else {
          setUser(null);
          setLoadingUser(false);
        }
          const videos = await fetchVideos();       //first useEffect sets videos
          setVideos(videos); 
      });

      return () => unsubscribe();
    }, []);


      const loadFullUserProfile = async (firebaseUser) => {
        try {
          const docRef = doc(db, "users", firebaseUser.uid);
          const docSnap = await getDoc(docRef);
          const data = docSnap.exists() ? docSnap.data() : {};

          const wordsSnap = await getDocs(collection(db, "users", firebaseUser.uid, "userWords"));
          const userWords = wordsSnap.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
          }));

          const fullUser = {
            ...firebaseUser,
            ...data,
          };

          const trophies = data.trophiesWon || {};

          setUser(fullUser);
          setTrophiesWon(trophies);
          setTempUserWords(userWords);
          setUserWordsCount(userWords.length);
          ttsUsageRef.current = {
            count: data.ttsPlayCount || 0,
            date: data.ttsPlayLastUsed || new Date().toISOString().split("T")[0],
          };
          lookUpRef.current = {
            count: data.defSentCount || 0,
            date: data.defSentLastUsed || new Date().toISOString().split("T")[0],
          };
          cardsSwipedRef.current = data.cardsSwiped || 0;

          return trophies;

        } catch (err) {
          console.error("Error loading user data:", err);
        } finally {
          setLoadingUser(false);
        }
      };

          useEffect(() => {
          if (videos || videos.length) return;
          initializeTrophies(videos, trophiesWon);      //  second(1) useEffect sets trophies
          console.log("trophies initialized")
        }, [videos, trophiesWon]);

const initializeTrophies = async (videos, trophiesWon) => {
           
      const updatedTrophies = { ...trophiesWon };
      let trophiesChanged = false;

      videos.forEach(video => {
        const segment = video.segment || "_full";
        const videoID = video.videoID;
        if (!videoID) return;

        const trophyKey = `${videoID}${segment}`;

        if (!updatedTrophies[trophyKey]) {
          updatedTrophies[trophyKey] = {
            Hangman: false,
            WordScramble: false,
            SentenceScramble: false,
            Quiz: false
          };
          trophiesChanged = true;
        }
      });

      if (trophiesChanged) {
        setTrophiesWon(updatedTrophies);
       await updateFirestoreTrophies(updatedTrophies);
      }
    }


    const fetchVideos = async () => {
      try {
        const q = query(collection(db, "videos"), orderBy("dateCreated", "desc"));
        const querySnapshot = await getDocs(q);
        const videosData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        return videosData
      } catch (error) {
        console.error("Error fetching videos:", error);
        return []
      }
    };
  


    useEffect(() => {
      if (vocabLoaded || videos.length === 0) return;
      try {
      const mostRecentVideo = videos[0]
      if (!mostRecentVideo) return;                                    //second useEffect setsTodays Vocab
      const saved = localStorage.getItem("todaysVocab");
      let vocab = mostRecentVideo.definitionsAndSentences || [];
       if (saved) {
      try {
        vocab = JSON.parse(saved);
      } catch {
        console.warn("Failed to parse saved vocab");
      }
    }
      setTodaysVocab(vocab);
      setVocabLoaded(true);
      setVideoVocab(vocab);
      setQuizPoints(mostRecentVideo.quizPoints || []);
      setStart(mostRecentVideo.start || 0);
      setIncludedVocab(mostRecentVideo.includedVocab || []);
      setVideoID(mostRecentVideo.videoID || "");

      const safeSegment = mostRecentVideo.segment || "_full";
      setTrophyKey(`${mostRecentVideo.videoID}${safeSegment}`);

    } catch (error) {
      console.error("Error fetching featured video vocab:", error);
    }

}, [videos, vocabLoaded]);


  // const clearUserData = () => {
  //   setTrophiesWon({});
  // };

 
      return (
        <DataContext.Provider value={{
          data, setData,
          synonyms, setSynonyms,
          summaryData, setSummaryData,
          defAndSent, setDefAndSent,
          todaysVocab, setTodaysVocab,
          videoVocab, setVideoVocab,
          includedVocab, setIncludedVocab,
          start, setStart,
          quizPoints, setQuizPoints,
          trophiesWon, setTrophiesWon,
          videoID, setVideoID,
          tempUserWords, setTempUserWords,
          userWordsCount,
          videos, setVideos,
          vocabMatchesBool, setTrophyKey, trophyKey,
          ttsUsageRef, lookUpRef, cardsSwipedRef,
          loadingUser, user, setUser
        , vocabLoaded, loadFullUserProfile
        }}>
          {children}
        </DataContext.Provider>
      );
      };

      export const useMyData = () => useContext(DataContext);
